/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'Components/Modal';
import Message from 'Components/Modal/Message';
import { useDispatch } from 'react-redux';
import { resetHRBetSlip } from 'Store/actions/horseRacing/betSlipActions';
import { toggleHRBetSlip } from 'Store/actions/horseRacing';
import { saveTjkCoupon } from 'Store/actions/horseRacing/couponActions';
import History from 'Store/history';
import Icon from 'Components/Icon';
import { withMixpanel } from 'Utils/mixpanel';
import EnvironmentManager from 'Utils/environmentManager';
import Input from 'Components/Input';
import { oddFormatter } from 'Utils/decimalFormatter';
import InsufficientFundsModal from 'Components/BetSlip/Modals/InsufficientFundsModal';

// success play
export const TjkPlayCouponSuccessModal = props => {
  const { modalClose, onPrimaryClick, result } = props;
  const dispatch = useDispatch();

  const isSingleSuccess = result.success === 1 && result.fail === 0 && result.timeout === 0;
  const isAllWaiting = result.timeout > 0 && result.fail === 0 && result.success === 0;
  const isPartiallyFailAndWaiting = result.success === 0 && result.timeout > 0 && result.fail > 0;
  const waitingText = EnvironmentManager.getMessageText({ key: 'description_tjk_betslip_waiting_coupon_text' });

  const getHorseName = propositionId => {
    const horse = result?.horses.find(p => p?.horse?.propositionInfo.propositionId === propositionId)?.horse;
    if (horse?.uniqId) {
      return horse.horseNo + ' ' + horse.name;
    }
    return horse?.propositionInfo?.horseNumbers + ' ' + horse?.propositionInfo?.horseNames;
  };

  return (
    <Modal
      title={ isAllWaiting || isPartiallyFailAndWaiting ? 'Kuponun Bekleniyor' : 'Kuponun Başarıyla Oynandı' }
      iconName={ isAllWaiting || isPartiallyFailAndWaiting ? 'svgInfoYellow' : 'svgLike' }
      type={ isAllWaiting || isPartiallyFailAndWaiting ? 'waiting' : 'success' }
      onClose={ modalClose }
      buttonArea={ {
        primaryButton: {
          label: 'KUPONLARIMA GİT',
          onClick: () => {
            dispatch(toggleHRBetSlip(false));
            onPrimaryClick();
          },
        }
      } }>
      <Message
        type="none"
      >
        { isAllWaiting && <span>{ waitingText }</span> }
        { isSingleSuccess && !isAllWaiting ? <span>
        Kuponunu “<b>At Yarışı Kuponlarım</b>” içerisinde “<b>Devam Eden</b>” sekmesinde görebilirsin.
        </span>
          : <div className='tjk-play-coupon-success-modal-multiple'>
            { result.success !== 0 ? <div className='tjk-play-coupon-success-modal-multiple-item'>
              <Icon iconName="svgIconSuccess"/>
              <strong> { result.success } </strong> tane kuponun başarıyla oynandı.
            </div> : null }
            { result.timeout !== 0 && !isAllWaiting ? <div className='tjk-play-coupon-success-modal-multiple-item'>
              <Icon iconName="svgIconWaiting"/>
              <strong> { result.timeout } </strong> tane kuponun bekleniyor.
            </div> : null }
            { result.fail !== 0 ? <div className='tjk-play-coupon-success-modal-multiple-item'>
              <Icon iconName="svgIconFailed"/>
              <strong> { result.fail } </strong> tane kuponun oynanamadı.
            </div> : null }
          </div>
        }
        {
          result?.fixedOdd?.oddChanges?.length > 0  && <div className="tjk-changed-odd-info">
            <span>{ EnvironmentManager.getMessageText({ key: 'v1.betslip_fixodd.rate_changed' }) }</span>
            <div className="change-info">
              <div className="change-info-header"><Icon iconName="svgMegafoneCircle"/>Oran Değişikliği</div>
              <div className="changes-list">
                {
                  result?.fixedOdd?.oddChanges?.map((oddChange, i) => (
                    <div key={ i } className="change-item">
                      <div className="odd-horse-name">
                        { getHorseName(oddChange?.propositionId) }
                      </div>
                      <div className="gny">
                        { result?.horses.find(p => p?.horse?.propositionInfo.propositionId === oddChange?.propositionId)?.bet?.description }
                      </div>
                      <div className="odds">
                        <div className="item">
                          Eski Oran: <strong
                            className="old">{ oddFormatter(oddChange?.clientOdd) }</strong> { oddChange?.changeDirection === 'DOWN'
                              ? <Icon iconName="svgOddDown"/> : <Icon iconName="svgOddUp"/> }
                        </div>
                        <div className="item">
                          Yeni Oran: <strong>{ oddFormatter(oddChange?.responseOdd) }</strong>
                        </div>
                      </div>
                    </div>
                  ))
                }
              </div>

            </div>
          </div>
        }
      </Message>
    </Modal>
  );
};

TjkPlayCouponSuccessModal.propTypes = {
  modalClose: PropTypes.func,
  onPrimaryClick: PropTypes.func,
  result: PropTypes.object,
};


const getFailureModalButtonConfig = (errorDomainCode, modalClose, dispatch, mixpanel) => {
  const paraYatır = {
    label: 'PARA YATIR',
    onClick: () => {
      mixpanel.track('Click Action Button on Insufficient Balance Popup in Horse Racing', {
        'Click Action Button': 'Para Yatır'
      });
      History.push('/hesabim/para-yatir');
      dispatch(toggleHRBetSlip(false));
      modalClose();
    },
  };

  const editAmount = {
    label: 'TUTARI DÜZENLE',
    onClick: () => {
      mixpanel.track('Click Action Button on Unsuccess Popup in Horce Racing', {
        'Click Action Button': 'Tutarı Düzenle'
      });
      dispatch(toggleHRBetSlip(true));
      modalClose();
    },
  };

  const program = {
    label: 'PROGRAMA GİT',
    onClick: () => {
      mixpanel.track('Click Action Button on Unsuccess Popup in Horce Racing', {
        'Click Action Button': 'Programa Git'
      });
      dispatch(toggleHRBetSlip(false));
      modalClose();
    },
  };

  const clearCoupon = {
    label: 'KUPONU TEMİZLE',
    onClick: () => {
      mixpanel.track('Click Action Button on Unsuccess Popup in Horce Racing', {
        'Click Action Button': 'Kuponu Temizle'
      });
      dispatch(resetHRBetSlip());
      dispatch(toggleHRBetSlip(true));
      modalClose();
    }
  };

  const santra = {
    label: EnvironmentManager.getMessageText({ key: 'button_turn_back_to_santra' }) || "SANTRA'YA DÖN",
    onClick: () => {
      mixpanel.track('Click Action Button on Unsuccess Popup in Horce Racing', {
        'Click Action Button': EnvironmentManager.getMessageText({ key: 'button_turn_back_to_santra' }) || "Santra'ya Dön"
      });
      History.push('/');
      dispatch(toggleHRBetSlip(false));
      modalClose();
    }
  };

  const cancel = {
    label: 'KAPAT',
    onClick: () => {
      mixpanel.track('Click Action Button on Unsuccess Popup in Horce Racing', {
        'Click Action Button': 'X'
      });
      modalClose();
    }
  };


  switch (errorDomainCode) {
    case 'tjk-coupon-api1017':
      return {
        secondary: {
          ...cancel
        }
      };

    case 'tjk-coupon-api1001':
      return { primary: { ...paraYatır } };

    case 'tjk-mobile-bff1003':
      return {
        primary: {
          ...editAmount
        }
      };

    case 'tjk-mobile-bff1002':
      return {
        primary: {
          ...editAmount
        }
      };

    case 'tjk-program-api1005':
      return {
        primary: {
          ...program
        },
        secondary: {
          ...clearCoupon
        }
      };
    case 'tjk-program-api1004':
      return {
        primary: {
          ...program
        },
        secondary: {
          ...clearCoupon
        }
      };

    case 'tjk-mobile-bff1013':
      return {
        primary: {
          ...program
        },
      };
    case 'tjk-program-api1007':
      return {
        primary: {
          ...cancel
        },
      };
    case 'tjk-coupon-api1004':
      return {
        primary: {
          ...program
        },
        secondary: {
          ...clearCoupon
        }
      };
    case 'tjk-mobile-bff1012':
      return {
        primary: {
          ...santra
        }
      };

    default:
      return {
        primary: {
          ...program
        }
      };
  }

};

// failure play
export const TjkPlayCouponFailureModal = withMixpanel(props => {
  const { modalClose, text, errorDomainCode, errorTitle, mixpanel } = props;
  const dispatch = useDispatch();

  if (errorDomainCode === 'tjk-coupon-api1001') {
    return (
      <InsufficientFundsModal
        onClose={ modalClose }
        onSaveCoupon={ () => dispatch(saveTjkCoupon()) }
        onDepositClick={ () => {
          History.push('/hesabim/para-yatir');
          dispatch(toggleHRBetSlip(false));
        } }
        gameType="horseracing"
      />
    );
  }

  const modalTitle = errorTitle ? errorTitle : 'Kuponunuz Oynanamadı';
  return (
    <Modal
      title={ modalTitle }
      iconName="svgPlayFailure"
      type="error"
      onClose={ () => {
        mixpanel.track('Click Action Button on Unsuccess Popup in Horce Racing', {
          'Click Action Button': 'X'
        });
        modalClose();
      } }
    >
      <Message
        type="none"
        buttonConfig={ getFailureModalButtonConfig(errorDomainCode, modalClose, dispatch, mixpanel) }
      >
        <span>
          { text }
        </span>
      </Message>
    </Modal>
  );
});

TjkPlayCouponFailureModal.propTypes = {
  modalClose: PropTypes.func,
  text: PropTypes.string,
  errorDomainCode: PropTypes.string,
  errorTitle: PropTypes.string,
  mixpanel: PropTypes.object
};

// coupon information
export const TjkCouponInformationModal = props => {
  const { modalClose, onPrimaryClick, text } = props;

  return (
    <Modal
      title={ EnvironmentManager.getMessageText({ key: 'title_tjk_clean_betslip' }) || 'Kupon Uyarısı' }
      iconName="svgInfoGreen"
      type="success"
      onClose={ modalClose }
      buttonArea={ {
        primaryButton: {
          label: EnvironmentManager.getMessageText({ key: 'button_clean_all' }) || 'TEMİZLE',
          onClick: () => {
            onPrimaryClick();
          },
        },
        secondaryButton: {
          label: EnvironmentManager.getMessageText({ key: 'button_cancel' }) || 'VAZGEÇ',
          onClick: () => {
            modalClose();
          },
        },
      } }
    >
      <Message
        type="none"
      >
        <span>
          { text || 'Farklı bir oyun seçtiğin için kuponuna daha önce eklediğin seçimler temizlenecek. Kabul ediyor musun?' }
        </span>
      </Message>
    </Modal>
  );
};


export const TjkSaveCouponSuccessModal = props => {
  const { modalClose, onPrimaryClick } = props;
  const [name, setName] = useState(null);

  return (
    <Modal
      title={ EnvironmentManager.getMessageText({ key: 'title_tjk_betslip_ask_coupon_saving' }) || 'Kuponunuz Kaydedildi' }
      iconName="svgLike"
      onClose={ modalClose }>
      <Message
        type="none"
        buttonConfig={ {
          primary: {
            label: EnvironmentManager.getMessageText({ key: 'button_save_uc' }),
            onClick: () => {
              onPrimaryClick(name);
            },
          }
        } }
      >
        <span>
          { EnvironmentManager.getMessageText({ key: 'description_tjk_betslip_ask_coupon_saving' }) }
        </span>

        <div
          className="tjk-save-coupon-success-modal-input">
          <Input
            name={ EnvironmentManager.getMessageText({ key: 'description_tjk_betslip_coupon_saved_give_name' }) }
            id='name'
            value={ name }
            type='text'
            autoComplete='off'
            onChange={ e => {
              const { value } = e.target;
              if (value.length > 15) return;
              setName(value.replace(/^\s+/, ''));
            } }
            clearInput={ () => {
              setName('');
            } }
            validateOnBlur
            onBlur={ e => {
              const { value } = e.target;
              if (value.trim() !== '') {
                setName(value);
              }
            } }
          />
        </div>

      </Message>
    </Modal>
  );
};

TjkSaveCouponSuccessModal.propTypes = {
  modalClose: PropTypes.func,
  onPrimaryClick: PropTypes.func,
  modalData: PropTypes.object
};

TjkCouponInformationModal.propTypes = {
  modalClose: PropTypes.func,
  onPrimaryClick: PropTypes.func,
  onSecondaryClick: PropTypes.func,
  text: PropTypes.string
};
